import { useAccount, useChainId, useWalletClient } from 'wagmi'
import { createPublicClient, http, PublicClient } from 'viem';
import { useSelector } from 'react-redux';
import { rpc } from '@/store';
import { chains } from '@/utils/wagmi';

export function useWeb3React() {
  const chainId = useChainId();
  const { address } = useAccount()
  const _rpc = useSelector(rpc);
  const currentChain = chains.find(c => c.id === chainId);

  const publicClient = createPublicClient(
    {
      batch: {
        multicall: true,
      },
      chain: currentChain,
      transport: http(_rpc)
    }
  )

  const { data: walletClient } = useWalletClient()


  return {
    chainId: chainId,
    account: address,
    provider: publicClient as PublicClient,
    walletClient: walletClient,
  }
}